import type { MetaBrowserSignals } from "./meta-signals"
import type { MetaClientBuilderStatus } from "./meta-client-param-builder"

export type MetaCompanionKind = "page-view" | "search"

export const sendMetaAnalyticsCompanion = async ({
  kind,
  eventId,
  signals,
  searchQuery,
  catalogContentIds,
  clientBuilderStatus,
}: {
  kind: MetaCompanionKind
  eventId: string
  signals: MetaBrowserSignals
  searchQuery?: string
  catalogContentIds?: string[]
  clientBuilderStatus?: MetaClientBuilderStatus
}): Promise<void> => {
  const response = await fetch(`/storefront-api/analytics/meta/${kind}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      eventId,
      eventSourceUrl: signals.eventSourceUrl,
      referrerUrl: signals.referrerUrl,
      consent: signals.consent,
      fbp: signals.fbp,
      fbc: signals.fbc,
      externalId: signals.externalId,
      ...(searchQuery ? { searchQuery } : {}),
      ...(catalogContentIds?.length
        ? { catalogContentIds: catalogContentIds.slice(0, 100) }
        : {}),
      ...(clientBuilderStatus ? { clientBuilderStatus } : {}),
    }),
    keepalive: true,
  })
  if (!response.ok && response.status !== 204) {
    throw new Error(`Meta companion rejected with status ${response.status}`)
  }
}
